import React, { useState, useEffect } from 'react';
import { LoadingSpan } from '../../../Loadings/loadingSpan';
import { KTSVG } from '../../../../../../_metronic/helpers';
import { initialLetters } from '../../../../../utils/initialLetters';
import { tempoPassado } from '../../../../../utils/date';
import { deleteCommentOne, getCommentsAll, postComment } from '../../../../../services/commentsService';
import { useToast } from '../../../Toats';
import { useQuery } from 'react-query';
import { useFormik } from 'formik';
import { useAuth } from '../../../../../modules/auth';

export function CommentsPlant({data}: any) {
    const [loadingPost, setLoadingPost] = useState<boolean>(false);
    const [startComment, setStartComment] = useState<boolean>(false);
    const { toggleToast } = useToast();
    const {currentUser} = useAuth();

    const [initialValues] = useState<any>({
        content: "",
        idPlant: data && data.id ? data.id : null,
        idUser: currentUser && currentUser.id ? currentUser.id : null
      })

    const { data: comments = [], isLoading: loading, refetch } = useQuery(
        ["getMyComments"],
        async () => {
            const comments = await getCommentsAll(data && data.id ? data.id : "")
            return comments;
        },
        {
          onError: (error) => {
            console.log(error);
          },
        }
    )

    const postComments = async () => {
        try {
            setLoadingPost(true)
          const myData = {
            content: formik.values.content,
            idPlant: formik.values.idPlant ? formik.values.idPlant: "",
            idUser: formik.values.idUser ? formik.values.idUser: ""
          }
          await postComment(myData);
          toggleToast("Sucesso comentar. ", "success");
    
        } catch (error) {
          console.log('erro',error)
          toggleToast("Erro ao comentar. ", "error")
        }finally{
            setLoadingPost(false)
          //closed()
          formik.setValues({...formik.values, content: ""})
          setStartComment(false)
          refetch()
        }
    }

    const deleteComment = async (id: string) => {
        try {
            setLoadingPost(true)

          await deleteCommentOne(id);
          toggleToast("Sucesso ao excluir comentário. ", "success");
    
        } catch (error) {
          console.log('erro',error)
          toggleToast("Erro ao excluir comentário. ", "error")
        }finally{
            setLoadingPost(false)
          //closed()
          formik.setValues({...formik.values, content: ""})
          setStartComment(false)
          refetch()
        }
    }

    const formik = useFormik({
        initialValues,
        //validationSchema,
        validateOnChange: false,
        onSubmit: () => {},
      });

  return (
    <div className='d-flex flex-column flex-grow-1' style={{height: '35rem'}}>
        <div
            className='card border border-gray-300 border-dashed rounded py-3 px-4 d-flex flex-wrap'
            style={{flexDirection: 'column', width: '100%', height: '100%'}}  
        >
            <div style={{height: '100%'}}>
                <div>
                    <input
                        onClick={() => setStartComment(true)}
                        type='text'
                        className='form-control form-control-lg form-control-solid'
                        name='description'
                        //disabled={formik.values.idFunnel || !loadingFunnel ? false : true}
                        placeholder='Digite um comentário'
                        value={formik.values.content}
                        onChange={formik.handleChange("content")}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' && !loading && !loadingPost) {
                                e.preventDefault(); 
                                postComments();
                            }
                        }}
                    />
                    {startComment && (
                    <div style={{width: '100%', display: 'flex', justifyContent: 'end', alignItems: 'center', gap: '0.5rem', marginTop: '0.7rem'}}>
                        <button
                            type='button'
                            className='btn btn-sm btn-light'
                            //disabled={loading || !formik.values.idFunnel}
                            //data-kt-stepper-action='submit'
                            onClick={() => {
                                formik.setValues({...formik.values, content: ""})
                                setStartComment(false)
                            }}
                        >
                            {
                            loading ? 
                            <LoadingSpan style={{marginRight: '0.5rem'}}/>
                            :
                            <KTSVG
                                path='/media/icons/duotune/arrows/arr063.svg'
                                className='svg-icon-3 ms-0 me-2'
                            />
                            }

                            Cancelar
                        
                        </button>
                        <button
                            type='button'
                            className='btn btn-sm btn-primary'
                            disabled={loading || loadingPost}
                            //data-kt-stepper-action='submit'
                            onClick={postComments}
                        >
                            Comentar
                        {
                            loading || loadingPost ? 
                            <LoadingSpan style={{marginLeft: '0.5rem'}}/>
                            :
                            <KTSVG
                                path='/media/icons/duotune/arrows/arr064.svg'
                                className='svg-icon-3 ms-2 me-0'
                            />
                        }
                        </button>
                    </div>)}
                </div>

                <div className='card border border-gray-300 border-dashed rounded p-4 d-flex flex-wrap mt-5' style={{height: startComment ? '74%' : '83%', overflow: 'auto'}}>
                    {comments.length <= 0 && (
                        <div className='bg-light' 
                            style={{
                                width: '100%', 
                                height: '100%', 
                                display: 'flex', 
                                alignItems: 'center', 
                                justifyContent: 'center',
                                gap: '0.5rem',
                                flexDirection: 'column'
                            }}
                        >
                            <KTSVG
                                path="/media/icons/duotune/general/gen004.svg"
                                className='svg-icon-3x me-1'
                            />
                            <h3 className='card-title d-flex align-items-center justify-content-center flex-column'>
                            <span className='text-muted fw-semibold fs-7'>Sem comentarios!</span>
                            </h3>
                        </div>
                    )}
                    {comments.length > 0 && (
                        <div style={{display: 'flex', flexDirection: 'column', gap: '1rem'}}>
                            {comments.map((comment: any) => {
                                return (
                                    <div className='d-flex' style={{alignItems: 'center', gap: '0.5rem'}}>
                                        <div className='symbol symbol-30px symbol-circle'>
                                            {/* <img src={toAbsoluteUrl("/media/avatars/300-6.jpg")} /> */}

                                            <div className='symbol symbol-30px symbol-circle'>
                                                <span className={`symbol-label bg-light-primary text-primary fs-9 fw-bolder`}>
                                                    {comment.user && comment.user.name ? initialLetters(comment.user.name) : "Não identificado."}
                                                </span>
                                                {/* <div className='symbol-badge bg-success start-100 top-100 border-4 h-15px w-15px ms-n3 mt-n3'></div> */}
                                            </div>
                                        </div>
                                        <div className='' style={{width: '100%'}}>
                                            <div className='d-flex justify-content-start flex-column bg-light p-2'>
                                                <a href='#' className='text-dark fw-bold text-hover-primary fs-8' style={{display: 'flex', alignItems: 'center', gap: '0.5rem'}}>
                                                    {comment.user && comment.user.name ? comment.user.name : "Não encontrado. "}
                                                    {" "}
                                                    .
                                                    {" "}
                                                    <span className='text-muted d-block fs-9'>
                                                        {comment.created_at ? tempoPassado(comment.created_at) : "0h"}
                                                    </span>
                                                </a>
                                                <span className='text-muted fw-semibold text-muted d-block fs-7'>
                                                    {comment && comment.content ? comment.content : "Nao encontrado"}
                                                </span>
                                            </div>
                                            {/* <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '0.5rem'}}>
                                                <span className='text-muted fw-semibold text-muted d-block fs-7'>
                                                    {comment.created_at ? tempoPassado(comment.created_at) : "0h"}
                                                </span>
                                            </div> */}
                                        </div>
                                        {currentUser?.role.slug !== "CLIENTE" ||
                                        currentUser?.id === comment.user.id &&
                                        <div>
                                            <button
                                                onClick={(event: any) => {
                                                    deleteComment(comment.id)
                                                }}
                                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                            >
                                                <KTSVG
                                                    path='/media/icons/duotune/general/gen027.svg'
                                                    className='svg-icon-3'
                                                />
                                            </button>
                                        </div>}
                                    </div>
                                )
                            })}
                        </div>
                    )}
                    
                </div>
                
            </div>
        </div>
    </div>
  );
}